export default __webpack_public_path__ + "static/media/ride_link_icon.2facc012.svg";